import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ShowAlert } from '@app/core/actions/alert';
import * as fromRoot from '@app/reducer';
import { isValidationError } from '@app/util';
import { Store } from '@ngrx/store';
import { createAlert } from '@util/alert-util';
import { StatusCode } from '@util/status-code';
import { both, either, when } from 'ramda';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const isErrorResponse = response => response instanceof HttpErrorResponse;
const validationError = ({error, status}) => isValidationError(status) && status.tardy;
const afterBadRequest = ({status}) => status > StatusCode.BAD_REQUEST;
const validationOrBadRequest = either(validationError, afterBadRequest);

const shouldShowAlert = both(isErrorResponse, validationOrBadRequest);

/**
 * Intercepts the responses and shows alerts in case of error.
 * If the error level is warning it shows an warning alert.
 * */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private clearAndShowAlert = (errorResponse) => {
    const error = errorResponse.error.body || errorResponse.error;
    const alert = createAlert(error);

    if (alert) {
      this.store.dispatch(new ShowAlert(alert));
    }
    return observableThrowError(errorResponse);
  };

  private showAlerts = (event: HttpEvent<any>): Observable<HttpEvent<any>> => {
    const showAlerts = when(shouldShowAlert, this.clearAndShowAlert);

    return showAlerts(event);
  };

  constructor(private store: Store<fromRoot.State>) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError(this.showAlerts));
  }
}
